import { REMI_SUPPORT_EMAIL, REMI_SUPPORT_NUMBER } from "@remi/constants";
import { RnEnvelope, RnPhone } from "@remi/icons/next";

export const RemiMaintenance = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-1">
      <div className="mb-4 text-text-primary">
        We apologize for any inconvenience. Our team is currently doing maintenance on the app.
      </div>
      <div>
        <a className="m-2 flex items-center gap-1 text-sm text-text-secondary" href={`mailto:${REMI_SUPPORT_EMAIL}`}>
          <RnEnvelope /> - {REMI_SUPPORT_EMAIL}
        </a>
        <a
          className="m-2 flex items-center gap-1 text-sm text-text-secondary"
          href={`tel:+1${REMI_SUPPORT_NUMBER.split(".").join("")}`}
        >
          <RnPhone /> - {REMI_SUPPORT_NUMBER}
        </a>
      </div>
    </div>
  );
};
